import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

const EarnestMoneyComponent = ({ contract }: { contract: Contract }) => {
  // Determine if there are any deposits
  const deposit1 = contract?.offerSpecifics?.deposit1;
  const deposit2 = contract?.offerSpecifics?.deposit2;
  const hasDeposit1 = deposit1 && deposit1 > 0;
  const hasDeposit2 = deposit2 && deposit2 > 0;
  const hasAnyDeposits = hasDeposit1;

  return (
    <View>
      <Text style={styles.title}>Earnest Money</Text>

      <View style={styles.list}>
        {!hasAnyDeposits && (
          <Text style={styles.listItem}>
            • There is no earnest money deposit or cash deposit on acceptance of
            this contract.
          </Text>
        )}

        {hasDeposit1 && (
          <Text style={styles.listItem}>
            • Buyer shall deposit{' '}
            <Text style={styles.bold}>
              ${contract?.offerSpecifics?.deposit1 ?? 'N/A'}
            </Text>{' '}
            as earnest money deposit with{' '}
            <Text style={styles.bold}>
              {contract?.thirdPartyTitleSettlement?.titleCompany ?? 'N/A'}
            </Text>{' '}
            on or before{' '}
            <Text style={styles.bold}>
              {contract?.offerSpecifics?.deposit1Due ?? 'N/A'}
            </Text>
            .
          </Text>
        )}

        {hasDeposit2 && (
          <Text style={styles.listItem}>
            • Buyer shall deposit{' '}
            <Text style={styles.bold}>
              ${contract?.offerSpecifics?.deposit2 ?? 'N/A'}
            </Text>{' '}
            as earnest money deposit with{' '}
            <Text style={styles.bold}>
              {contract?.thirdPartyTitleSettlement?.titleCompany ?? 'N/A'}
            </Text>{' '}
            on or before{' '}
            <Text style={styles.bold}>
              {contract?.offerSpecifics?.deposit2Due ?? 'N/A'}
            </Text>
            .
          </Text>
        )}

        {hasAnyDeposits && (
          <>
            <Text style={styles.listItem}>
              • If Buyer fails to deposit the earnest money as required by this
              Contract, Seller may terminate this Contract by providing written
              notice to Buyer within{' '}
              <Text style={styles.DangerText}>3 days</Text> after the deadline
              for Buyer's performance.
            </Text>

            <Text style={styles.listItem}>
              • If Buyer deposits the earnest money as required by this
              Contract, the earnest money shall be applied to the Purchase Price
              at Closing.
            </Text>
          </>
        )}
      </View>
    </View>
  );
};

export default EarnestMoneyComponent;
